import React from 'react'
import './App.css'
import { useRoutes } from 'react-router-dom'
import Footer from './components/Footer'
import Header from './components/Header'
import routes from './router'
export default function App() {
  const elements = useRoutes(routes)
  return (
    <>
      <Header />
      {elements}
      <Footer />
    </>
  )
}
